import Client1 from "../../images/c1.jpg";
import Client2 from "../../images/c2.jpg";
import Client3 from "../../images/c3.jpg";
import Client4 from "../../images/c4.jpg";
import Client5 from "../../images/c5.jpg";

export const TestimonialData = [
    {
      id: 1,
      name: "John Doe",
      Imag: Client1,
      say: "a book or other written or printed work, regarded in terms of its content rather than its physical form.",
    },
    {
      id: 2,
      name: "Mitchel",
      Imag: Client2,
      say: "a book or other written or printed work, regarded in terms of its content rather than its physical form.",
    },
    {
      id: 3,
      name: "Ruchell",
      Imag: Client3,
      say: "a book or other written or printed work, regarded in terms of its content rather than its physical form.",
    },
    {
      id: 4,
      name: "Sara",
      Imag: Client4,
      say: "a book or other written or printed work, regarded in terms of its content rather than its physical form.",
    },
    {
      id: 5,
      name: "Stark",
      Imag: Client5,
      say: "a book or other written or printed work, regarded in terms of its content rather than its physical form.",
    },
];
